var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInvestmentConsultation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2999A7;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14_00000065757196649376690780000006975462564402154892_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13-2_00000121972771892421356860000012736390254462662812_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84_00000166665226973015427710000012253252344377475231_",
    x: 1.8,
    y: 180.4,
    className: "st0",
    width: 196.5,
    height: 7.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7_00000088114894552439954220000005019652835285420447_",
    className: "st0",
    d: "M14.7,176.3h32.4c1.8,0,3.2-1.5,3.2-3.2 l0,0v-58.4c0-1.8-1.5-3.2-3.2-3.2c0,0,0,0,0,0H14.7c-1.8,0-3.2,1.5-3.2,3.2l0,0v58.4C11.5,174.9,13,176.3,14.7,176.3z M18,117.9 h26v51.9H18V117.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8_00000062895126108418915130000004203481145809949109_",
    className: "st0",
    d: "M105.6,176.3H138c1.8,0,3.2-1.5,3.2-3.2 c0,0,0,0,0,0V75.7c0-1.8-1.5-3.2-3.2-3.2l0,0h-32.4c-1.8,0-3.2,1.5-3.2,3.2v97.3C102.4,174.9,103.8,176.3,105.6,176.3z M108.8,79 h26v90.9h-26L108.8,79z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9_00000160876377000313718200000016652841092836695737_",
    className: "st0",
    d: "M60.2,176.3h32.4c1.8,0,3.2-1.4,3.2-3.1 V42.4c0-1.8-1.5-3.1-3.2-3.1H60.2c-1.8,0-3.2,1.4-3.2,3.1v130.8C57,175,58.4,176.3,60.2,176.3z M63.4,45.5h26v124.6h-26V45.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10_00000072281706060342498880000002497370988550399367_",
    className: "st0",
    d: "M151,176.3h32.4c1.7,0.1,3.2-1.2,3.2-2.9 V15.2c-0.1-1.7-1.5-3-3.2-2.9H151c-1.7-0.1-3.2,1.2-3.2,2.9v158.2C147.9,175.1,149.3,176.4,151,176.3z M154.3,18.1h26v152.3h-26 V18.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvestmentConsultation);
export default __webpack_public_path__ + "static/media/Icon_Investment_consultation.7c6445063080acef3977f08a5a5055fe.svg";
export { ForwardRef as ReactComponent };